import React, { useRef, useState } from 'react';
import CusPageCardContainer from '../shared/CusPageCardContainer';
import { useAppSelector } from '../../store';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Stack, Box, Button, Typography } from '@mui/material';
import Scrollbar from '../custom-scroll/Scrollbar';
import CasinoMenu from '../../views/settings/casino/CasinoMenu';
import ShowContainer from '../material-ui/ShowContainer';
import useBootstrapSize from '../../hooks/useBootstrapSize';
import { IconBurger, IconMenu } from '@tabler/icons-react';
import useColor from '../../hooks/site/useColor';

export default function CasinoContainer({ children, title, hideMenu = false }) {
  const { casinoId } = useParams();
  const { t } = useTranslation();
  const { isLessTablet, isMobile, isShortHeight } = useBootstrapSize();
  const { background } = useColor();
  const casinos = useAppSelector((state) => state.user.info.casino);

  const [openMenu, setOpenMenu] = useState(false);
  const openItemMenuInSetting = useRef();

  const casino = casinos.find((el) => el.id == casinoId);
  const casinoName = casino?.casinoName;

  const heightContent = 'calc(100svh - 220px)';

  const MenuBtn = () => (
    <IconMenu
      size={isMobile ? 20 : 24}
      style={{ cursor: 'pointer' }}
      onClick={() => setOpenMenu((prev) => !prev)}
    />
  );

  const MenuContainer = ({ children }) => {
    if (isLessTablet)
      return (
        <Box
          position={'fixed'}
          right={0}
          sx={{ background: background.default }}
          height={'100svh'}
          overflow={'auto'}
          top={isMobile ? 85 : 90}
          pr={isMobile ? 3 : 4}>
          <Box sx={{ display: 'flex', alignSelf: 'center', justifySelf: 'end' }} pr={1}>
            <MenuBtn />
          </Box>
          {children}
        </Box>
      );
    return children;
  };

  const backLink = casinoId ? `/settings/casino/${casinoId}` : `/settings/casino/`;
  const CasinoTitle = () => {
    const nameCasino = casinoName ? `"${casinoName}"` : '';
    if (isMobile)
      return (
        <>
          {t(title)}
          <br />
          {nameCasino}
        </>
      );

    return (
      <>
        {t(title)} {nameCasino}
      </>
    );
  };

  return (
    <CusPageCardContainer
      headTitle={title}
      title={
        <Stack
          display={'flex'}
          alignContent={'center'}
          direction={'row'}
          justifyContent={'space-between'}>
          <Typography variant="caption" fontSize={18} fontWeight={600}>
            <CasinoTitle />
          </Typography>
          <ShowContainer condition={isLessTablet && !openMenu}>
            <MenuBtn />
          </ShowContainer>
        </Stack>
      }
      backInfo={{
        getToLink: () => {
          const searchParam = openItemMenuInSetting.current
            ? `?openMenu=${openItemMenuInSetting.current}`
            : '';
          if (openItemMenuInSetting.current) return backLink + searchParam;
          return backLink;
        },
        text: 'Casino list',
        to: backLink
      }}
      cardSX={{ maxHeight: 'calc(100svh - 90px)', overflow: 'auto' }}>
      <Stack display={'flex'} direction={'row'} position={'relative'} gap={1}>
        <Box
          flex={1}
          maxHeight={isShortHeight || isMobile ? undefined : heightContent}
          overflow={'auto'}>
          <Box minHeight={'fit-content'} height={'100%'}>
            {React.Children.map(children, (child) => {
              if (React.isValidElement(child)) {
                return React.cloneElement(child, {
                  casino: casino
                });
              }
              return child;
            })}

            {/* {children} */}
          </Box>
          {/* <Scrollbar
          sx={{
            flex: 1,
            maxHeight: isShortHeight || isMobile ? undefined : heightContent,
            minHeight: 'fit-content'
          }}
          alsoMobile>
          {children}
        </Scrollbar> */}
        </Box>

        <ShowContainer condition={!hideMenu && (!isLessTablet || (isLessTablet && openMenu))}>
          <MenuContainer>
            <Scrollbar
              sx={{
                width: '260px',
                maxHeight: heightContent,
                overflow: 'auto'
              }}>
              <CasinoMenu
                casinoId={casinoId}
                openItemMenuInSetting={openItemMenuInSetting}
                isDelete
              />
            </Scrollbar>
          </MenuContainer>
        </ShowContainer>
      </Stack>
    </CusPageCardContainer>
  );
}
